import api from "./api";

// Dias feriados: por dia y mes (se repiten cada anio) o por fecha completa.
const diaFeriadoService = {
    getsDiaFeriado: async () => {
        const response = await api.get("/DiaFeriado/GetsDiaFeriado");
        return response.data.data || [];
    },

    addUpdateDiaFeriado: async (diaFeriado) => {
        const response = await api.post("/DiaFeriado/AddUpdateDiaFeriado", diaFeriado);
        return response.data.data;
    },

    deleteDiaFeriado: async (idDiaFeriado) => {
        const response = await api.post("/DiaFeriado/DeleteDiaFeriado?idDiaFeriado=" + idDiaFeriado);
        return response.data.data;
    },

    // Dias laborables entre las dos fechas, ya descontando los feriados que no se
    // laboran y los dias de la semana marcados como feriado en la configuracion.
    getsDiasLaborables: async (fechaInicio, fechaFin) => {
        const response = await api.get("/DiaFeriado/GetsDiasLaborables", {
            params: { fechaInicio, fechaFin },
        });
        return response.data.data;
    },
};

export default diaFeriadoService;
